import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import axios from 'axios'
// Components
import Navbar from './components/Navbar';
import SideBar from './components/SideBar';
// Pages
import home from './pages/home';  
import map from './pages/map';  
import submit from './pages/submit';  
import info from './pages/info';  

axios.defaults.baseURL = 'https://us-central1-aus-corona-map.cloudfunctions.net/api'

function App() {
  return (
    <div>
      <Router>
        <Navbar />
          <Switch>           
            <Route exact path ='/' component={info} />
                <Route exact path ='/map' component={map} />
            <div className='container'>
                <Route exact path ='/summary' component={home} />
                <Route exact path ='/submit' component={submit} />
            </div>
          </Switch>
      </Router>
    </div>
  );
}

export default App;
